module.exports = __webpack_public_path__ + "img/rangers-logo-icon.2938dd7d.png";